import InstanceSettings from './InstanceSettings';

export const PAGE_INSTANCE_SETTINGS = '/instance-settings';

export default InstanceSettings;
